import * as amplitude from "@amplitude/analytics-browser";
import { enableForEnv, Stages } from "~/lib/utils";
import logger from "./logger";

// Types for events
export interface EventProperties {
  [key: string]: any;
}

export interface TrackingEvent {
  eventName: string;
  properties?: EventProperties;
}

// Utility function to track events
export const trackEvent = (event: TrackingEvent) => {
  try {
    if (
      enableForEnv([
        Stages.PRODUCTION,
        Stages.STAGING,
        Stages.DEV,
        Stages.LOCAL,
      ])
    ) {
      amplitude.track(event.eventName, event.properties);
      logger.info("Amplitude event:", event);
    } else {
      logger.info("Amplitude event dev log:", event);
    }
  } catch (error) {
    logger.error("Error tracking event:", error);
  }
};
